module.exports = __webpack_public_path__ + "static/media/img4.ecb93c28.jpeg";